import * as React from 'react';
import {NotificationPanel} from './notification-panel';


export const NotificationPanelRoute = () => {
  return <NotificationPanel isOpen={true} onClose={() => undefined} />;
};

export default NotificationPanelRoute;
